// extracted by mini-css-extract-plugin
export default {"overlayContainer":"OperationsGroup__overlayContainer___jqVu5","subOperation":"OperationsGroup__subOperation___jhMUf"};